// Barrel for the auction IsomorphicServices (ADR 010).
// BL-983: the cascade resolver + summary formatter live in `@auctogon/core`
// (bidder-web cannot depend on core-admin) and are re-exported here so admin
// call sites keep one import path. (BL-2032 deleted the calculator's re-export:
// nothing imported it.)
// They replaced `isUsableBp` and `resolveCreateAuctionBuyersPremium`, both
// deleted in the same change.
export { resolveBuyersPremium, formatBuyersPremium } from '@auctogon/core/buyers-premium';
export type {
  BuyersPremiumSource,
  ResolvedBuyersPremium,
  FormatBuyersPremiumOptions,
  // BUG-1043: the formatters' input type, so a caller narrowing an untyped JSONB
  // read before calling `formatBuyersPremium` keeps to this one import path
  // rather than reaching past the shim into `@auctogon/core` for the type alone.
  BuyersPremiumLike,
} from '@auctogon/core/buyers-premium';
export type { BpCalculationType, BuyersPremiumInput, BuyersPremiumTierInput } from './types';
// BL-1065: lot-eligibility status allowlist, shared by the client picker + the
// server associate backstop.
export {
  auctionAcceptsLotsFromRow,
  LOT_ELIGIBLE_AUCTION_STATUS_LABELS,
  LOT_ELIGIBLE_AUCTION_STATUSES,
  TARGET_AUCTION_NOT_ACCEPTING_LOTS_MESSAGE,
} from './lot-eligibility';
// BL-1286: the go-live gate (BL-747), moved here from admin-web so shared
// response DTOs can reference `AuctionReadyBlocker`. Matrix §4.2 generalizes it
// from Draft → Ready to every publishing transition.
export { getAuctionReadyBlockers, readyBlockersToFieldErrors } from './auction-ready-gate';
export type { AuctionReadyBlocker, AuctionReadyGateInput } from './auction-ready-gate';
// BUG-1714: the ring "First lot closes" value rules — past-instant and
// before-opens — shared by the roster save, the Basics save and the gate above.
export {
  closeTimeIsInPast,
  describeRingClosesBeforeOpens,
  describeRingClosesBeforeOpensBlocker,
  describeStartAfterRingClose,
  findRingsClosingBeforeOpens,
  ringClosesAtOrBeforeOpens,
} from './ring-close-schedule';
export type { RingClosingBeforeOpens } from './ring-close-schedule';
